<template>
  <div>
    <little-header class="max-w-640 m-auto"></little-header>
    <div class="bg-grey-light share-poster-page appBody prh-main d-flex flex-column-reverse align-items-center">
      <van-overlay :show="showTip" @click="showTip = false">
        <div class="text-white position-absolute tipInfo" style="top:0; right: 0; padding: 1rem 2rem;">
          <img class="w-100" src="/static/img/pro/sharetip.png" alt="">
        </div>
      </van-overlay>
      <div class="w-100 footer-button">

        <div class="bg-white w-100 p-3 poster-list">

          <van-tabs v-model="activeName" @click="changePoster">
            <van-tab v-for="(bgImg,index) in posterHtmlBgList" :key="index" :name="'bgImg'+index">
              <template #title>
                <div class="img active position-relative" :class="{'border-disable': bgImg===''}"
                     :style="{backgroundImage: 'url('+bgImg+')'}">
                  <svg t="1593422684292" class="icon d-none position-absolute" viewBox="0 0 1024 1024" version="1.1"
                       xmlns="http://www.w3.org/2000/svg" p-id="46815" width="16" height="16">
                    <path d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z" fill="#5796EF"
                          p-id="46816"></path>
                    <path
                      d="M460.8 592.457143l234.057143-234.057143c14.628571-14.628571 36.571429-14.628571 51.2 0 14.628571 14.628571 14.628571 36.571429 0 51.2L482.742857 672.914286c-14.628571 14.628571-36.571429 14.628571-51.2 0L277.942857 519.314286c-14.628571-14.628571-14.628571-36.571429 0-51.2 14.628571-14.628571 36.571429-14.628571 51.2 0l131.657143 124.342857z"
                      fill="#FFFFFF" p-id="46817"></path>
                  </svg>
                </div>
              </template>
            </van-tab>

          </van-tabs>
        </div>
        <div class="share-btns w-100 px-3 py-2 d-flex justify-content-between align-items-center">
          <p v-if="!isPc" class="mb-0 color-88 font-14" @click="wxTip">
            <img class="mr-1" src="/static/img/pro/weixinShare.png">
            微信分享
          </p>
          <a v-if="isPc" class="color-88 font-14 d-flex align-items-center" :href="posterImg" download="图片">
            <img class="mr-1" src="/static/img/pro/load.png">
            下载图片
          </a>
          <p class="mb-0 color-88 font-14 cursor-pointer" @click="copyUrl">
            <img class="mr-1" src="/static/img/pro/lianjie1.png">
            复制链接
          </p>
        </div>
      </div>
      <div class="pos-content">
        <div class="w-100 h-100 d-flex align-items-center align-items-center poster-block " ref="p_text">
          <div class=" w-80 overflow-hidden bg-white" v-show="activeName==='bgImg0'">
            <div class="h-100 overflow-hidden posterHtml0" id="posterHtml0">
              <div class="bg-white w-100 px-4 py-4 h-68 bg-block big-code">
                <div ref="qrcodeImgqrCodeUrl0" id="qrcodeImg0"></div>
              </div>
              <div class="bg-white px-3 py-3 w-100 d-flex justify-content-between align-items-center">
                <div class="">
                  <img class="w-80" src="/static/img/index/logo.png" alt="">
                  <div class="c-title-h first-title">
                    {{title}}
                  </div>
                  <p class="mb-0 color-33 font-10 mt-1">
                    {{witeUrl}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="w-80 overflow-hidden bg-white" v-show="activeName==='bgImg1'">
            <div class="h-100 overflow-hidden" id="posterHtml1">
              <div class="bg-white w-100 p-4 h-75 bg-block"
                   :style="{backgroundImage: 'url('+posterHtmlBgList[1]+')'}">
                <img class="w-50" src="/static/img/index/logo.png" alt="">
                <div class="bg-white position-relative title-block">
                  <div class="c-title-h  font-13 mb-1 line-18">
                    {{title}}
                  </div>
                  <p class="mb-0 font-11 color-33" v-if="username">
                    {{username?username:''}} 邀请你加入安丘专技教育
                  </p>
                </div>
              </div>
              <div class="bg-white p-3 w-100 h-25 d-flex justify-content-between align-items-center">
                <div class="mr-3 poster-footer">
                  <p class="mb-0 color-33 font-11">浏览器输入访问码直达</p>
                  <p class="mb-0 color-33 font-10 mt-1">
                    <img class="h-1r" src="/static/img/index/favicon.ico" alt="">
                    {{witeUrl}}</p>
                  <div
                    class="blue-tip bg-base font-10 text-white mt-2 d-flex align-items-center justify-content-between">
                    识别二维码查看
                    <!--{{pgType}}-->
                    <svg t="1593428542722" class="icon" viewBox="0 0 1024 1024" version="1.1"
                         xmlns="http://www.w3.org/2000/svg" p-id="51096" width="14" height="14">
                      <path
                        d="M498 116C277.1 116 98 295.1 98 516s179.1 400 400 400 400-179.1 400-400-179.1-400-400-400z m-77.5 615.7L380 691.3 555.4 516 380 340.7l40.4-40.4L636.2 516 420.5 731.7z"
                        p-id="51097" fill="#ffffff"></path>
                    </svg>
                  </div>
                </div>
                <div class="qrcode">
                  <div ref="qrcodeImgqrCodeUrl1" id="qrcodeImg1" class="qrcodeImg"></div>
                </div>
              </div>

            </div>
          </div>
          <div class="w-80 overflow-hidden  bg-white" v-show="activeName==='bgImg2'">
            <div class="h-100 overflow-hidden" id="posterHtml2">
              <div class="bg-white w-100 p-4 h-75 bg-block"
                   :style="{backgroundImage: 'url('+posterHtmlBgList[2]+')'}">
                <img class="w-50" src="/static/img/index/logo.png" alt="">
                <div class="bg-white position-relative title-block">
                  <div class="c-title-h font-13 mb-1 line-18">
                    {{title}}
                  </div>
                  <p class="mb-0 font-11 color-33">
                    {{username?username:''}} 邀请你加入安丘专技教育
                  </p>
                </div>
              </div>
              <div class="bg-white p-3 w-100 h-25 d-flex justify-content-between align-items-center">
                <div class="mr-3 poster-footer">
                  <p class="mb-0 color-33 font-11">浏览器输入访问码直达</p>
                  <p class="mb-0 color-33 font-10 mt-1">
                    <img class="h-1r" src="/static/img/index/favicon.ico" alt="">
                    {{witeUrl}}</p>
                  <div
                    class=" blue-tip bg-base font-10 text-white mt-2 d-flex align-items-center justify-content-between">
                    识别二维码查看
                    <svg t="1593428542722" class="icon" viewBox="0 0 1024 1024" version="1.1"
                         xmlns="http://www.w3.org/2000/svg" p-id="51096" width="14" height="14">
                      <path
                        d="M498 116C277.1 116 98 295.1 98 516s179.1 400 400 400 400-179.1 400-400-179.1-400-400-400z m-77.5 615.7L380 691.3 555.4 516 380 340.7l40.4-40.4L636.2 516 420.5 731.7z"
                        p-id="51097" fill="#ffffff"></path>
                    </svg>
                  </div>
                </div>
                <div class="qrcode">
                  <div ref="qrcodeImgqrCodeUrl2" id="qrcodeImg2" class="qrcodeImg"></div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import Vue from 'vue';
  import {Tab, Tabs} from 'vant';
  import {Overlay} from 'vant';
  import LittleHeader from "@/components/littleHeader";
  Vue.use(Overlay);
  Vue.use(Tab);
  Vue.use(Tabs);

  import QRCode from 'qrcodejs2'
  import html2canvas from 'html2canvas'
  import Cookies from 'js-cookie'

  export default {
    name: "shareMaPop",
    data() {
      return {
        activeName: 'bgImg0',
        posterImg: '', // 最终生成的海报图片
        posterContent: '', // 文案内容
        shareObj: {},
        posterHtmlBgList: [
          '/static/img/pro/tupian.png',
          '/static/img/pro/poster1.jpg',
          '/static/img/pro/poster2.jpg',

        ],
        isChecked: false,
        title: '',
        summary: '',
        username: '',
        pgType: '',
        witeUrl: 'www.aqjsjx.com.cn',
        showTip: false,
        isPc: false
      }
    },
    components: {
      LittleHeader
    },
    watch: {},
    mounted() {
      if (window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
        //跳转移动端页面
        this.isPc = false;
      } else {
        //跳转pc端页面
        this.isPc = true;
      }
      if(Cookies.get('u_info')) {
        let userInfo = JSON.parse(Cookies.get('u_info'));
        if (userInfo && userInfo.name) {
          this.username = userInfo.name
        } else {
          this.username = '';
        }
      }

      // let rm = $('.share-btns').css("fontSize");
      // let pd = rm.slice(0, -2) * 3;
      let height = $('.appBody').height() - $('.footer-button').height();
      let width = ((height) * 13) / 16;
      $('.pos-content').css('height', height);
      $('.pos-content').css('width', width);
      this.$nextTick(() => {
        this.getShareObj();
      })
    },
    methods: {
      getShareObj() {
        if (localStorage.getItem('share_obj') && localStorage.getItem('share_obj')) {
          this.shareObj = JSON.parse(localStorage.getItem('share_obj'));
          // this.posterContent = this.shareObj.title;
          console.log(this.shareObj.fromPageType)
          if (this.shareObj.fromPageType === 'project') {
            this.pgType = '项目';
            this.title = this.shareObj.name;
            this.summary = this.shareObj.summary;
          } else if (this.shareObj.fromPageType === 'pcourse') {
            this.pgType = '课程';
            this.title = this.shareObj.course.title;
            this.summary = this.shareObj.course.summary;
          } else if (this.shareObj.fromPageType === 'course') {
            this.pgType = '课程';
            this.title = this.shareObj.title;
            this.summary = this.shareObj.summary;
          } else if (this.shareObj.fromPageType === 'index') {
            this.pgType = '安丘专技教育';
            this.title = '安丘专技教育';
            this.summary = '';
          } else if (this.shareObj.fromPageType === 'news') {
            this.pgType = '新闻';
            this.title = this.shareObj.title;
            this.summary = this.shareObj.summary;
          }

          this.createQrcode(0);
          this.createQrcode(1);
          this.createQrcode(2);

          this.createPoster(0);

        } else {
          this.shareObj = {}
        }
      },
      createQrcode(num) {
        // 生成二维码
        const wid = $('.big-code').width();
        const hei = $('.big-code').height();
        const qrcodeImgEl = this.$refs['qrcodeImgqrCodeUrl' + num];

        if (num === 0) {
          new QRCode(qrcodeImgEl, {
            text: this.shareObj.qrcodeUrl,
            width: wid,
            height: hei,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H
          });
        } else {
          new QRCode(qrcodeImgEl, {
            text: this.shareObj.qrcodeUrl,
            width: 64,
            height: 64,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H
          });
        }
      },
      createPoster(num) {
        // 生成海报
        const vm = this;
        vm.posterImg = '';
        let upDom = this.$refs.p_text;//要生成的dom元素之上所有元素包裹盒
        let upDomHeight = upDom.offsetHeight;//包裹盒子高度
        let width = upDom.offsetWidth;

        setTimeout(() => {
          const domObj = document.getElementById('posterHtml' + num);
          html2canvas(domObj, {
            useCORS: true,
            allowTaint: false,
            logging: false,
            letterRendering: true,
            scrollY: 0,
            scrollX: 0,
            onclone(doc) {
              let e = doc.querySelector('#posterHtml' + num);
              e.style.display = 'block';
            }
          }).then(function (canvas) {
            // 在微信里,可长按保存或转发
            vm.posterImg = canvas.toDataURL('image/png');
            $('#posterHtml' + num).html('<img class="h-100 w-100" src="' + vm.posterImg + '"/>')
            // $('#posterHtml'+num).html('<a href="'+vm.posterImg+'" download="图片"><img class="w-100" src="'+vm.posterImg+'"/></a>')
          }).catch((e) => {
            console.log(e)
          })
        }, 0);

      },
      changePoster(name) {
        let num = name.substr(-1);
        let pos = $('#posterHtml' + num);
        if (pos.children().length === 1) {
          return;
        } else {
          if (document.getElementById('posterHtml' + num)) {
            this.createPoster(num);
          }
        }


      },

      wxTip() {
        this.showTip = true;
      },
      copyUrl() {
        //这里的链接从shareObj中取
        let Url = this.shareObj.qrcodeUrl;

        let oInput = document.createElement("input");
        oInput.value = Url;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象
        document.execCommand("Copy"); // 执行浏览器复制命令
        oInput.className = "oInput";
        oInput.style.display = "none";
        this.$toast({
          message: "复制成功",
          type: 'success'
        })
      }
    }
  }
</script>

<style>
  /*.poster-list {*/
  /*height: 100%;*/
  /*}*/

  .share-poster-page .first-title {
    font-size: 13px;
    line-height: 18px;
    overflow: hidden;
    max-height: 36px;
    margin-top: 16px;
    margin-bottom: 8px;
  }
  .pos-content .w-80 {
    width: 80%;
    height: 95%;
    margin: 0 auto !important;
  }
  .border-disable {
    border: none !important;
    pointer-events: none !important;
  }
  .share-poster-page .share-btns {
    background: #ffffff;
    border-top: 1px solid #e3e3e3;
    font-size: 1rem;
    /*box-shadow: 0 0 5px 3px #e3e3e342;*/
  }
  .share-poster-page .van-hairline--top-bottom::after,
  .share-poster-page .van-hairline-unset--top-bottom::after {
    border-width: 0;
    border-bottom: none !important;
  }

  .share-poster-page .van-tabs--line .van-tabs__wrap {
    height: 4rem;
  }

  .share-poster-page .van-tabs__line {
    display: none;
  }

  .share-poster-page .c-title-h {
    max-height: 36px;
    font-size: 12px !important;
    line-height: 18px;


  }
  .share-poster-page .mt-20 {
    margin-top: 20px;
  }
  .share-poster-page .mt-1 {
    margin-top: 4px !important;
  }
  .share-poster-page .mt-2 {
    margin-top: 8px !important;
  }
  .share-poster-page .mb-3 {
    margin-bottom: 16px !important;
  }
  .share-poster-page .font-10 {
    font-size: 10px;
  }
  .share-poster-page .font-11 {
    font-size: 11px;
  }
  .share-poster-page .van-tab--active .img {
    border: 2px solid #2474ff;
  }

  .share-poster-page .van-tab--active .img .icon {
    display: block !important;
  }

  .posterHtml0 .bg-block {

    display: flex;
    align-items: center;
    justify-content: center;
  }

  .bg-block {
    background-size: cover;
  }

  .title-block {
    top: 1.75rem;
    margin-left: 1rem;
    margin-right: 1rem;
    padding: 12px;
  }

  .poster-list .img {
    width: 4rem;
    height: 4rem;
    overflow: hidden;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    margin-right: .75rem;
  }

  .poster-list .img {
    border: 1px solid #e3e3e3;
  }

  .poster-list .img .icon {
    border: 2px solid #ffffff;
    border-radius: 50%;
    right: .25rem;
    top: .25rem;
  }

  .poster-block .h-1r {
    height: .75rem;
  }

  .poster-block .bg-base {
    border-radius: .25rem;
  }

  .poster-block .qrcodeImg img {
    border-radius: .25rem;
    width: 64px;
    height: 64px;
  }

  .poster-footer {
    max-width: 13.5rem;
    overflow: hidden;
  }

  .poster-footer .blue-tip {
    width: 130px;
    font-size: 10px;
    line-height: 22px;
    padding: 0 8px;

  }

  .share-poster-page .tipInfo {
    max-width: 640px;
    margin: 0 auto;
    top: 0;
    left: 0;
    right: 0;
    padding: 1rem 2rem;
  }

  .share-poster-page .van-tabs__wrap--scrollable .van-tab {
    flex-basis: 4rem !important;
    flex: 0 0 4rem !important;

  }
</style>
